// import { MoreVert } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

const StatsCards = ({ data, handleOptionsClick }: any) => {
  return (
    <Box
      sx={{
        boxShadow: "0px 1px 3px 0px #0000001A",
        p: 2,
        minHeight: "145px",
        bgcolor: "#FFFFFF",
        borderRadius: "16px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box
          sx={{
            width: "60px",
            height: "60px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "12px",
            bgcolor: data?.color,
            mb: 1.5,
          }}
        >
          <Box
            sx={{
              width: "50px",
              height: "50px",
              borderRadius: "8px",
              border: "2px solid #FFFFFF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography color={"#FFFFFF"} fontWeight={"bold"} variant="h3">
              {data?.value}
            </Typography>
          </Box>
        </Box>
        {/* <Box>
          <IconButton onClick={(e) => handleOptionsClick(e, data)}>
            <MoreVert />
          </IconButton>
        </Box> */}
      </Box>
      <Typography
        variant="body2"
        sx={{ color: "text.secondary", fontWeight: "medium" }}
      >
        {data?.title}
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{ color: "#1F2A37", fontWeight: "bold" }}
      >
        {data?.desc}
      </Typography>
    </Box>
  );
};

export default StatsCards;
